import { Dialog, DialogTitle, DialogActions, DialogContent, Typography, Button } from "@mui/material";
import { DeleteAccountDialogType } from "../actions/data";
import { DialogContentContainer, DialogContentItem } from "./styles";

const DeleteAccountDialog = (props: DeleteAccountDialogType) => {

  const {open, onClose, account, onDeleteAction} = props;

  const warningMessageLine1 = 'YOU ARE ABOUT TO DELETE THIS ACCOUNT.' 
  const warningMessageLine2 = 'THIS IS NOT REVERSIBLE!!!'
  
  return <Dialog open={open} onClose={onClose}>
    <DialogTitle>DELETE ACCOUNT</DialogTitle>
    <DialogContent>
      <DialogContentContainer>
        <DialogContentItem>
          <Typography>{warningMessageLine1}</Typography>
          <Typography fontWeight={'600'}>{warningMessageLine2}</Typography>
        </DialogContentItem>
        <DialogContentItem>
          <Typography>Account: {account?.id}</Typography>
          <Typography>Company Name: {account?.companyName}</Typography>
        </DialogContentItem>
      </DialogContentContainer>
    </DialogContent>
    <DialogActions>
      { account?.id &&
        <Button variant='contained' color='error' onClick={() => onDeleteAction(account)}>Delete Account</Button>
      }
      <Button variant='outlined' onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
}

export default DeleteAccountDialog;